import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import routes from '../../../shared/routes';
import httpClient from '../../../shared/libraries/httpClient';

import TransactionDetails from './TransactionDetails';
import TransactionPDF from './TransactionPDF';

const Transaction = ({ transactionId, urls, signInRoutes, recaptchaKey, recaptchaWidgetSrc }) => {
  const [transactionBalance, setTransactionBalance] = useState(null);
  const [transaction, setTransaction] = useState(null);

  const fetchTransaction = async id => {
    const { data } = await httpClient.get(routes.billing.transactions.fetch({ id }));
    setTransaction(data.transaction);
    setTransactionBalance(data.balance);
  };

  useEffect(() => {
    fetchTransaction(transactionId);
  }, [transactionId]);

  let title = transactionId;
  let createdAt;
  let balanceChange;
  let lineItemTitle;
  let transactionType;
  let notification;
  let reference;
  let reason;

  if (transaction) {
    title = transaction.title;
    createdAt = transaction.createdAt;
    lineItemTitle = transaction.lineItemTitle;
    transactionType = transaction.transactionType;
    notification = transaction.notification;
    reference = transaction.reference;
    reason = transaction.reason;
  }

  if (transactionBalance) {
    balanceChange = {
      before: transactionBalance.before,
      after: transactionBalance.after,
      amount: transaction.amount,
      currency: transactionBalance.currency,
    };
  }

  return (
    <TransactionDetails
      title={title}
      transactionType={transactionType}
      timestamp={createdAt}
      balanceChange={balanceChange}
      urls={urls}
      lineItem={lineItemTitle}
      signInRoutes={signInRoutes}
      recaptchaKey={recaptchaKey}
      recaptchaWidgetSrc={recaptchaWidgetSrc}
      pdf={
        <div className="button button--v2">
          <TransactionPDF transactionId={transactionId} />
        </div>
      }
      notification={notification}
      reference={reference}
      reason={reason}
    />
  );
};

Transaction.propTypes = {
  transactionId: PropTypes.number.isRequired,
  urls: PropTypes.shape({
    billing: PropTypes.string.isRequired,
    transactions: PropTypes.string.isRequired,
    thisInvoice: PropTypes.string.isRequired,
  }).isRequired,
  signInRoutes: PropTypes.shape({
    signInUrl: PropTypes.string.isRequired,
  }).isRequired,
  recaptchaKey: PropTypes.string.isRequired,
  recaptchaWidgetSrc: PropTypes.string.isRequired,
};

export default Transaction;
